import { Image, Text, View } from 'components';
import Base, { Config } from 'components/sixshot/Base';
import React from 'react';
import styles from './index.module.scss';


const LEVEL_SILVER = 1
const LEVEL_GOLD = 2
const COLUMN_LIST = [
  {column: "free_call", name: '一年内招聘随便打'},  //2024-01-24
  {column: "score", name: '赠送积分', 
    display: (obj:any) => {
      return (obj.value || '')+'积分'
    }
  },
  {column: "combo", name: '替班包年卡'},
  // {column: "law", name: '律师在线法务咨询权',
  //   display: (obj:any) => {
  //     return (obj.value || '')+'次/年'
  //   }
  // },
  {column: "law", name: '防拖欠工资保障服务'},  //2024-01-24
  {column: "pact", name: '法律保障的电子劳动合同'},  //2024-01-24
  {column: "quality", name: '优质老板推荐'},
  {column: "resume_push", name: '司机名片全国置顶',
    display: (obj:any) => {
      return (obj.value || '')+'天'
    }
  },  //2024-01-24
  {column: "sms_notice", name: '有声音短信提醒'},  //2024-01-24
  {column: "question", name: '维修专家免费故障咨询',
    display: (obj:any) => {
      return (obj.value || '')+'次'
    }
  },  //2024-01-24
  
  {column: "fault", name: '故障代码+最全解决方案'},
  {column: "course", name: '零基础学挖机维修视频课'},
  {column: "vlog", name: '维修妙招视频免费看'},  //2024-01-24
  {column: "box", name: '智能云盒代理权'},
  {column: "agent", name: '年赚3万+的代理机会'},
  {column: "icon", name: '专属钻石标识简历'},
  {column: "insurance", name: '个人意外死亡伤残险'},
  
]


interface State {
  vipList: {
    days: number
    id: number
    info_list: any
    level: number   //1：银会员；   2：金会员
    type: number    //1长期；  2替班
    name: string
    price: string
    cost: string
    status: number
  }[]
  currentLevel: 1 | 2  //当前选中的
  vipInfo: any,
  type: number   // 1长期；  2替班钻石会员
}

export default class VipCompaire extends Base<any, State> {
  public config: Config = {
    navigationBarTitleText: '会员特权'
  };

  public state: State = {
    vipList: [],
    currentLevel: LEVEL_GOLD,
    vipInfo: {},
    type: 1
  };

  public async didMount() {
    // await this.getUserInfo();
    const params:any = this.navigator.getParams(' '+this.props.location.search) || {}
    const col = (this.props.location.state || {}).type
    this.setState({
      type: params.type || col || 1,
    })


    this.init()
  }

  public render() {
    const { currentLevel, vipInfo } = this.state;

    return (
      <View className={styles.container} style={{backgroundImage: 'url('+this.assets.sixshot.vipCompaireBg+')'}}>
        
        <View className={styles.lists}>
          <View className={styles.title}>{this.isTiban? '替班': ''}会员权益对比</View>
          <View className={styles.th}>
            <View className={styles.sp1}>特权</View>
            <View className={styles.sp2}>金钻{this.isTiban? '替班': '会员'}</View>
            <View className={styles.sp3}>银钻{this.isTiban? '替班': '会员'}</View>
          </View>


          {this.FilterColumnList.map(res => {
            const goldRes = ((this.vipGold.info_list || []).find(e => e.column == res.column) || {})
            const silvRes = ((this.vipSilver.info_list || []).find(e => e.column == res.column) || {})
            return (
              <View className={styles.td} key={res.column}>
                <View className={styles.sp1}>{res.name}</View>
                <View className={styles.sp2}>
                  <Text className={styles.red}>{
                    !goldRes.status? '/':
                      res.display? 
                        res.display(goldRes): '有'
                  }</Text>
                </View>
                <View className={styles.sp3}>{
                  !silvRes.status? '/':
                  res.display? 
                    res.display(silvRes): '有'
                }</View>
              </View>
            )
          })}


          <View className={styles.btnBack} onClick={this.handleBack}>点此返回</View>
        </View>

        <View className={styles.bottomFixed}>
          {this.vipGold && 
            <View className={this.cx(styles.bottomBtns, {
              [styles.tiban]: this.isTiban
            })}>
              {[this.vipGold, this.vipSilver].map((res, ind) => (
                <View className={this.cx(styles.btn, {
                  [styles.active]: res.level == currentLevel
                })} key={ind} onClick={this.handleClickPay.bind(null, res)}>
                  {res.level == LEVEL_GOLD && <View className={styles.limit}>推荐</View>}
                  <View className={styles.tit}>
                    <Text className={styles.h2}>{(res.name || '').replace('会员', '司机')}</Text>
                    {/* {res.level == LEVEL_GOLD? 
                      <Text className={styles.tag}>含律师</Text>:
                      <Text className={styles.tag}>不含律师</Text>
                    } */}
                  </View>
                  <View className={styles.price}>
                    <Text className={styles.sm}>￥</Text>
                    <Text>{Number(res.price || 0)}/年</Text>
                    <Text className={styles.p}>{'点此支付>>'}</Text>
                  </View>
                </View>
              ))}
            </View>
          }
        </View>

      </View>
    );
  }

  private get isTiban() {
    const { type } = this.state
    return type == 2
  }

  private get vipGold() {
    const { vipList, type } = this.state
    let res:any = vipList.find(e => (e.level == LEVEL_GOLD && e.type == type)) || {}
    return {...res, alias: '金钻'}
  }
  private get vipSilver() {
    const { vipList, type } = this.state
    let res:any =  vipList.find(e => (e.level == LEVEL_SILVER && e.type == type)) || {}
    return {...res, alias: '银钻'}
  }
  private get vipSelected() {
    const { vipList, type, currentLevel } = this.state
    let res:any =  vipList.find(e => (e.level == currentLevel && e.type == type)) || {}
    return res
  }
  private get vipInfoGold() {
    return this.vipGold? this.vipGold.info_list || []: []
  }
  private get vipInfoSilv() {
    return this.vipSilver? this.vipSilver.info_list || []: []
  }

  private get FilterColumnList() {
    //重整后的列表顺序
    let result:any[] = []
    this.vipInfoGold.map(res => {
      const a = COLUMN_LIST.find(e => e.column == res.column) || {}
      result.push({
        ...res,
        ...a
      })
    })
    return result
  }




  private handleBack = () => {
    if(this.interface.uaEnv.isWechatMp()){
      window.wx.miniProgram.navigateBack()
    }else if(this.interface.uaEnv.isReactNative) {
      this.interface.postMessage('back')
    }else {
      this.navigator.back()
    }
  }

  private handleClickPay = (obj) => {
    this.setState({
      currentLevel: obj.level
    })
    
    if(this.interface.uaEnv.isWechatMp()) {
      window.wx.miniProgram.redirectTo({url: '/pages/vip/webview/index?type=compaire&payId='+obj.id})
    }else if(this.interface.uaEnv.isReactNative){
      this.interface.postMessage({
        routeName: 'vipJsyzh',
        routeParams: {
          payId: obj.id
        }
      })
      // this.interface.postMessage('back')
    }else {
      this.handlePay(obj.id)
    }
  }

  private handlePay = async (id) => {
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }
    
    const response = await this.apiClient.base.vipPlusBuy({
      id
    });

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        alert('购买成功');

      }
    });
  }


  private getUserInfo = async () => {
    // const { body } = await this.apiClient.base.userinfo();

    // const res = await this.apiClient.base.vipPlusInfo()
    // this.setState({
    //   vipInfo: body
    // })
  }

  private init = async() => {
    const { body } = await this.apiClient.base.vipPlus({})
    if(body) {
      this.setState({
        vipList: body || []
      })
    }
  }  
  
}
